import * as React from 'react';
import styled from 'styled-components';
import { FlexCol, FlexRowCenter } from './Flexbox/Flexbox';
import { rem } from 'polished';
import { Icon } from './Defaults';
import { __ } from 'react-i18n';

const Wrapper = styled(FlexCol)`
  width: 100%;
  color: #aaaaaa;
  position: relative;

  &:focus-within {
    color: ${props => props.theme.colors.btnPrimary};
  }
`;

const SelectLabel: any = styled.p`
  height: ${(props: any) => (props.label ? 'auto' : '0')};
  margin: 10px 0;
  font-size: ${({ theme }) => theme.fontSizeXS};
  font-family: ${({ theme }) => theme.primaryFont};
`;
const DropdownIcon = styled(FlexRowCenter)`
  width: ${rem(6)};
  height: ${rem(3)};
  position: absolute;
  right: ${rem(15)};
  bottom: ${rem(18)};
`;

const StyledSelect = styled.select`
  width: 100%;
  height: ${rem(40)};
  background: transparent;
  border: ${({ theme }) => rem(theme.formElements.border.width)} solid
    ${({ theme }) => theme.formElements.border.color};
  border-radius: ${({ theme }) => rem(theme.formElements.border.radius)};
  color: ${props => props.theme.colors.textPrimary};
  font-size: ${rem(16)};
  padding: ${rem(9)} ${rem(15)};
  appearance: none;

  &:focus {
    border-color: ${({ theme }) => theme.formElements.border.colorOnFocus};
    outline: none;
    box-shadow: 0 0 ${rem(8)}
      ${({ theme }) => theme.formElements.border.colorOnFocus};
  }
`;

interface SelectProps {
  id?: string;
  name?: string;
  label?: string;
  value: string | number | undefined;
  options: {
    name: string;
    value: string;
  }[];
  autoComplete?: string;
  defaultValue?: {
    name: string;
    value: string | undefined | number;
  };
  onChange: (e: any) => void;
  onBlur?: () => void;
}

export class Select extends React.Component<SelectProps> {
  static defaultProps: Partial<SelectProps> = {
    name: 'select',
    defaultValue: {
      name: __('Vyberte položku zo zoznamu'),
      value: '',
    },
    autoComplete: 'off',
    onBlur: () => {
      /**/
    },
  };

  shouldComponentUpdate(nextProps) {
    return (
      this.props.options !== nextProps.options ||
      this.props.value !== nextProps.value
    );
  }

  render() {
    const {
      name,
      options,
      value,
      onChange,
      id,
      label,
      onBlur,
      defaultValue,
      autoComplete,
    } = this.props;

    return (
      <Wrapper>
        <SelectLabel label={label}>{label}</SelectLabel>
        <DropdownIcon>
          <Icon src={'/images/arrow_triangle.svg'} />
        </DropdownIcon>
        <StyledSelect
          id={id ? id : ''}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          autoComplete={autoComplete}
        >
          <option value={defaultValue!.value}>{defaultValue!.name}</option>
          {options.map(option => (
            <option key={option.value} value={option.value}>
              {option.name}
            </option>
          ))}
        </StyledSelect>
      </Wrapper>
    );
  }
}
